document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bfcm2026-products').forEach(function (root) {
    var switchTrack = root.querySelector('.featured-collection-group-swiper__swiper-switch');
    if (!switchTrack) return;

    // 移动端分类条可横向滑动。点某一项后把它滚进可视区，避免选中项落在屏幕外。
    switchTrack.addEventListener('click', function (event) {
      var button = event.target.closest('.featured-collection-group-swiper__swiper-switch-button');
      if (!button || !switchTrack.contains(button)) return;
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      button.scrollIntoView({
        behavior: reduce ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    });
  });
});
